module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_path.js
// module id = 516
// module chunks = 17